class OfferGroupService {
    constructor(restangular, $q, settings, sortByKeys) {
        this._offerGroupRoute = restangular.one('OfferGroup');
        this.selectedGroup = undefined;
        this.settings = settings;
        this.sortByKeys = sortByKeys;
        this.$q = $q;
        this._groupCache = {};
    }

    selectOfferGroup(id) {
        if (!(id in this._groupCache)) {
            this._groupCache[id] = this._offerGroupRoute.one(id).get();
        }
        this.offerGroupPromise = this._groupCache[id].then((response) => {
            this.selectedGroup = response;
            return response;
        });
        return this.offerGroupPromise;
    }

    getSelectedOfferGroup() {
        return this.offerGroupPromise
            ? this.offerGroupPromise
            : this.$q.when(null);
    }

    getProducts(args) {
        this.selectedGroupTotalCount = undefined;
        return this._offerGroupRoute.one('Products').one(this.selectedGroup.Url).get(this.createArgs(args))
            .then((response) => {
                this.selectedGroupTotalCount = response.TotalRecordCount;
                return {
                    items: response.Items,
                    totalRecordCount: response.TotalRecordCount,
                };
            });
    }

    getSortOptions() {
        return {
            sortTypes: this.settings.browse.sortOptions,
            sortContext: this.sortByKeys.BROWSE_KEY,
        };
    }

    createArgs(args) {
        return {
            pageNumber: args.pageNumber,
            pageSize: args.pageSize || 10,
            sortType: args.sortType,
        };
    }
}

module.exports = OfferGroupService;



// WEBPACK FOOTER //
// ./src/shop/offergroup/offergroup.service.js